import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { initOctopusStore } from '@pegasus/abtesting';
import { octopusMiddleware } from '@client/lib/assignments';
import rootReducer from './rootReducer';
import { RootState } from './types';

export default function configureStore(initialState?: RootState) {
    const middleware = [thunk, octopusMiddleware];

    // https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
    let composeEhancers = compose;
    if (__DEV__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as any;
    }

    const enhancer = composeEhancers(applyMiddleware(...middleware));
    const store = createStore(rootReducer, initialState, enhancer);

    store.dispatch(initOctopusStore());

    if (module.hot) {
        module.hot.accept('./rootReducer', () => {
            // eslint-disable-next-line global-require
            const nextRootReducer = require('./rootReducer').default;
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
